import { render } from "./Currency.vue?vue&type=template&id=dd1218c2"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"
script.render = render

export default script